import { render, staticRenderFns } from "./recycleProject.vue?vue&type=template&id=28718414&scoped=true&"
import script from "./recycleProject.vue?vue&type=script&lang=js&"
export * from "./recycleProject.vue?vue&type=script&lang=js&"
import style0 from "./recycleProject.vue?vue&type=style&index=0&id=28718414&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28718414",
  null
  
)

export default component.exports